
/* injects from baggage-loader */

'use strict';

export default function (app) {
  app
    .factory('Dialog', DialogFactory);

  function DialogFactory($uibModal, $document) {
    'ngInject';

    let self = {};

    let modalParent = angular.element($document[0].querySelector('.stage-container'));

    self.showFail = function(title, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          title: () => title,
          text: () => text
        },
        appendTo: modalParent,
        windowClass: 'alert-modal'
      }).result.then(callback, cancelFn);
    };

    self.showAlert = function(label, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          label: () =>  label,
          text: () => text
        },
        appendTo: modalParent,
        windowClass: 'alert-modal',
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showBigAlert = function(label, text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogAlert',
        controllerAs: "$ctrl",
        resolve:{
          label: () =>  label,
          text: () => text
        },
        appendTo: modalParent,
        windowClass: 'alert-lg-modal',
        backdrop: 'static',
      }).result.then(callback, cancelFn);
    };

    self.showConfirm = function(text, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogConfirm',
        controllerAs: "$ctrl",
        resolve:{
          text: () => text
        },
        windowClass: 'confirm-modal',
        appendTo: modalParent,        
      }).result.then(callback, cancelFn);
    };

    self.showFeedback = function (texts, callback, cancelFn, hideChromaFrames){
      $uibModal.open({        
        component: 'dialogFeedback',
        controllerAs: "$ctrl",
        resolve:{
          texts: () => texts,
          hideChromaFrames: () => hideChromaFrames
        },
        appendTo: modalParent,          
        windowClass: 'feedback-modal',
        backdrop: 'static',
      }).result.then(callback, cancelFn).catch(cancelFn);
    };

    self.showTrophy = function(hasCarousel, callback, cancelFn){
      $uibModal.open({        
        component: 'dialogTrophy',
        controllerAs: "$ctrl",
        backdrop: 'static',
        resolve:{
          hasCarousel: () => hasCarousel
        },
        appendTo: modalParent,
        windowClass: 'feedback-trophies'
      }).result.then(callback, cancelFn).catch(cancelFn);
    };

    self.showIntroModal = function(callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogIntro',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
      }).result.then(callback, cancelFn);
    };  
    
    self.showInterventionalModal = function(title, ballons, callback, cancelFn){
      $uibModal.open({
        animation: false,
        component: 'dialogInterventional',
        controllerAs: "$ctrl",
        backdrop: false,
        keyboard: false,
        windowClass: 'interventional-modal',
        resolve: {
          title: () =>  title,
          ballons: () => ballons
        },
        appendTo: modalParent
      }).result.then(callback, cancelFn);
    };    

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/dialogs.factory.js